import { render } from "./DetailFeature.vue?vue&type=template&id=2dd51688"
import script from "./DetailFeature.vue?vue&type=script&lang=js"
export * from "./DetailFeature.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__